import { IOptions } from '../common/common.types'
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.readAsDataURL(blob)
  })
}

export const getSelectedDataFromObject = (
  jsonHeader: Record<string, any> = {},
  featureKeys: string[] = []
): Record<string, any> => {
  const data: Record<string, any> = {}
  featureKeys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(jsonHeader, key)) {
      data[key] = jsonHeader[key]
    }
  })
  return data
}

export const makeObjectsUnique = <T>(arr: T[], key: keyof T): T[] => {
  const uniqueMap = new Map<T[keyof T], T>()

  arr.forEach((obj) => {
    const keyValue = obj[key]
    if (!uniqueMap.has(keyValue)) {
      uniqueMap.set(keyValue, obj)
    }
  })

  return Array.from(uniqueMap.values())
}

export const isAgeLessThan = (age: number, ageUnit: string, compareAge: number) => {
  const unitMultipliers: any = {
    h: 1 / 8760,
    d: 1 / 365,
    m: 1 / 12,
    y: 1,
  }
  const ageInYears = age * unitMultipliers[ageUnit]
  return ageInYears < compareAge
}

export const renameObjectKey = (obj: any, oldKey: string, newKey: string) => {
  if (Object.prototype.hasOwnProperty.call(obj, oldKey)) {
    const newObj = { ...obj }
    newObj[newKey] = newObj[oldKey]
    delete newObj[oldKey]
    return newObj
  } else {
    return obj
  }
}

export const setDefaultValue = (optionsArr: IOptions, defaultId: number, dataPointConfig?: number) => {
  if (dataPointConfig !== undefined && !dataPointConfig) return null

  const obj = optionsArr.find((item) => item.id === defaultId)

  return obj ? obj : null
}

export const capitalizeFirstChar = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/* Safely sets a property on an object if that key already exists */
export const setDataToObject = <T extends object, K extends keyof T>(obj: T, key: K, value: T[K]): T => {
  if (!Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj
  }
  return { ...obj, [key]: value }
}
